import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  parentContainer: {
    width: '100%',
    height: '100%',
    padding: 0,
    flexGrow: 1,
    boxSizing: 'border-box',
  },
  ProductDetails: {
    '& .dx-data-row:first-child': {
      fontWeight: 'bold'
    }
  },
  iconStyle: {
    cursor: 'pointer',
    marginLeft: '5px',
  },
  commentStyles: {
    whiteSpace: 'pre-wrap',
    width: 700,
    height: 260,
    padding: '1rem',
  }
});
